// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching users
export const detAllSearch = createAsyncThunk(
  "search/detAllSearch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://api.recdbase.org/api/collect?query=all");
      console.log(response.data);
      
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Async thunk to fetch search results
export const fetchSearchResults = createAsyncThunk(
    "search/fetchSearchResults",
    async ({ searchTerm, selectedFilters }) => {
      const queryParams = new URLSearchParams();
      queryParams.append("query", "search");
      queryParams.append("search", searchTerm);
      
      if (selectedFilters.length > 0) {
        queryParams.append("selected", selectedFilters.join(","));
      }
  
      console.log(`Fetching search: ${queryParams.toString()}`); // ✅ Debug log
  
      const response = await axios.get(
        `https://api.recdbase.org/api/collect?${queryParams}`
      );
  
      console.log("Search API Response:", response.data); // ✅ Log API response
      return response.data;
    }
  );
  

  export const fetchAdvanceSearch = createAsyncThunk(
    "search/fetchAdvanceSearch",
    async ({ searchTermer, selectedFilterser }) => {
      const filters = selectedFilterser.join(" + "); // Format filters correctly
      const response = await axios.get(
        `https://api.recdbase.org/api/advance?query=search&search=${searchTermer}&advance_selected_items=${filters}`
      );
      console.log("Search API Response:", response.data); 
      return response.data;
    }
  );
  

const searchSlice = createSlice({
  name: "search",
  initialState: {
    searchTermer: null,
    selectedFilterser: [],
    data: [],
    dataer: [],
    datas: [],
    searchTerm: "",
    selectedFilters: [],
    status: "idle",
    loading: false,
    error: null,
  },
  reducers: {
    setSearchTerm: (state, action) => {
        state.searchTerm = action.payload;
      },
      
      clearSelectedBox: (state) => {
        state.selectedFilterser = [];
      },
      clearSearchTimer: (state) => {
        state.searchTermer = "";
      },
      toggleFilter: (state, action) => {
        const filter = action.payload;
        if (state.selectedFilters.includes(filter)) {
          state.selectedFilters = state.selectedFilters.filter((f) => f !== filter);
        } else {
          state.selectedFilters.push(filter);
        }
      },
      setSearchTermer: (state, action) => {
        state.searchTermer = action.payload;
        if (action.payload === "") {
          state.dataer = []; // Clear dataer when input is cleared
        }
      },
      toggleFilterer: (state, action) => {
        const filter = action.payload;
        if (state.selectedFilterser.includes(filter)) {
          state.selectedFilterser = state.selectedFilterser.filter(f => f !== filter);
        } else {
          state.selectedFilterser.push(filter);
        }
  
        if (state.selectedFilterser.length === 0) {
          state.dataer = []; // Clear dataer when no filters are selected
        }
      },
      clearDataer: (state) => {
        state.dataer = [];
      },
  }, // No reducers needed for async API calls
  extraReducers: (builder) => {
    builder
      .addCase(detAllSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(detAllSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(detAllSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
      builder
      .addCase(fetchAdvanceSearch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdvanceSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.dataer = action.payload;
      })
      .addCase(fetchAdvanceSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
      builder
  .addCase(fetchSearchResults.pending, (state) => {
    state.status = "loading";
  })
  .addCase(fetchSearchResults.fulfilled, (state, action) => {
    state.status = "succeeded";
    console.log("Search Data Received:", action.payload); // ✅ Debug log
    state.datas = action.payload; // ✅ Update only `datas`
  })
  .addCase(fetchSearchResults.rejected, (state, action) => {
    state.status = "failed";
    state.error = action.error.message;
    console.error("Search Fetch Error:", action.error.message); // ✅ Debug log
  });

  },
});
export const { setSearchTerm, toggleFilter, clearSelectedBox, clearSearchTimer, setSearchTermer, toggleFilterer, clearDataer} = searchSlice.actions;
export default searchSlice.reducer;
